exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".printForm{height:100%}.printForm p{color:#676767;font-style:italic}.printForm__container{display:flex;flex-wrap:wrap;margin-top:1rem;height:calc(100% - 8rem)}.printForm__panel{width:calc(50% - .5rem);height:calc(100% - 1rem);overflow:auto}.printForm__panel h3{padding-bottom:.75rem;margin-bottom:.75rem;border-bottom:1px solid #eee}.printForm__panel h4{font-size:.9rem;margin-top:1.5rem;margin-bottom:.5rem;padding-bottom:.5rem;color:#555;border-bottom:1px solid #eee}.printForm__panel .checkbox-wrap{margin-bottom:0}.printForm__sections{margin-right:1rem}.printForm__subsections{padding-left:1rem}.printForm__control{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7aa54567!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PrintForm/PrintForm.vue
// module id = 277
// module chunks = 0